<template>
    <div id="about-airvey-editions" class="container">
        <section class="row align-items-center padding-top-2x padding-bottom-2x text-justify">
            <p>
                Attention : Dorénavant, nous n'acceptons d'étudier que les propositions de polars (adultes ou jeunesse). Notre catalogue est complet pour tout autre genre.
            </p>
            <p>
                Notre préférence ira aux auteurs souhaitant éditer leur premier roman. Si vous avez déjà publié chez un ou d'autres éditeurs pour ce genre, nous souhaiterions connaître la raison de votre souhait de mutation. En effet, s'engager à publier et à promouvoir un auteur et son livre a un coût que nous souhaitons amortir.
            </p>
            <p>
                Pour nous contacter concernant votre projet de publication, veuillez tout d'abord nous remettre un synopsis et un résumé, ainsi qu'une courte présentation de vous-même (avec votre lieu de résidence). Si nous pensons qu'il y a une première adéquation avec notre ligne éditoriale, nous vous demanderons de nous communiquer votre tapuscrit pour étude de notre comité de lecture (réponse sous 6 semaines environ) et éventuelle publication (sous 3 à 6 mois environ).
            </p>
            <p>
                Notre délai de réponse à votre premier message ne dépassera pas la quinzaine de jours.
            </p>
            <p>
                <span class="text-less-bold">Sachez en plus</span> :<br>
                Airvey éditions est un éditeur à compte d'éditeur. Nos auteurs ne sont pas censés acheter leurs livres pour être publiés, et aucune participation aux frais n'est demandée.<br>
                Notre diffusion est réalisée par un diffuseur/distributeur compétant en France, Belgique, Luxembourg, introduit auprès des principales librairies et des Fnac, Cultura, Espace culturel Leclerc, Furet du Nord, Decitre... ainsi qu'auprès des leaders de la vente en ligne.<br>
                Airvey dépense presqu'exclusivement son budget communication en participant à de très nombreux salons du livre en France, Belgique et Suisse, c'est pourquoi il est demandé aux auteurs un minimum contractuel de présence sur ces salons les deux premières années, et également un minimum de séances de dédicaces en librairies. Il est nécessaire d'aimer ces contacts pour s'engager avec nous.
            </p>
            <p>
                Merci.
            </p>
            <p>
                Contact : <a href="mailto:airvey.editions@orange.fr" type="mail">airvey.editions@orange.fr</a>
            </p>
        </section>
    </div>
</template>

<script>
export default {
    name: "AboutAirveyEditions",
};
</script>

<style scoped>

</style>